import GenericDB from './generic-db';

export default class TriggerMailsDB extends GenericDB {
  constructor() {
    super('triggerMails');
  }

  /**
  * Send an e-mail based on a template
  * @param {array} toEmails
  * @param {string} template
  * @param {object} data
  */
  async sendMail(toEmails, template, data) {
    const mailObj = {
      to: toEmails,
      template: {
        name: template,
        data,
      },
    };
    return this.create(mailObj);
  }
}
